export default __webpack_public_path__ + "static/media/dc-martian.78565f7d.jpg";